export default __webpack_public_path__ + "static/media/redux-original.0093fdee.svg";